/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmitCardChallengeRequestDetails } from './SubmitCardChallengeRequestDetails';
import {
    SubmitCardChallengeRequestDetailsFromJSON,
    SubmitCardChallengeRequestDetailsFromJSONTyped,
    SubmitCardChallengeRequestDetailsToJSON,
    SubmitCardChallengeRequestDetailsToJSONTyped,
} from './SubmitCardChallengeRequestDetails';

/**
 * 
 * @export
 * @interface SubmitCardChallengeRequest
 */
export interface SubmitCardChallengeRequest {
    /**
     * 
     * @type {SubmitCardChallengeRequestDetails}
     * @memberof SubmitCardChallengeRequest
     */
    details: SubmitCardChallengeRequestDetails;
}

/**
 * Check if a given object implements the SubmitCardChallengeRequest interface.
 */
export function instanceOfSubmitCardChallengeRequest(value: object): value is SubmitCardChallengeRequest {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function SubmitCardChallengeRequestFromJSON(json: any): SubmitCardChallengeRequest {
    return SubmitCardChallengeRequestFromJSONTyped(json, false);
}

export function SubmitCardChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitCardChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'details': SubmitCardChallengeRequestDetailsFromJSON(json['details']),
    };
}

export function SubmitCardChallengeRequestToJSON(json: any): SubmitCardChallengeRequest {
    return SubmitCardChallengeRequestToJSONTyped(json, false);
}

export function SubmitCardChallengeRequestToJSONTyped(value?: SubmitCardChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'details': SubmitCardChallengeRequestDetailsToJSON(value['details']),
    };
}

